import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { SkillApiService } from '../skill-api';
import type {
    WebSkillListParams,
    WebSkillListResponse,
    WebSkillDetailItem,
    WebSkillCreateRequest,
    WebSkillCreateData,
    WebSkillEnableData,
    WebSkillDeleteData,
} from '../../types';

@injectable()
export class SkillApiServiceImpl extends PsHttpService implements SkillApiService {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/hub-api/web/skill`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    getList(params?: WebSkillListParams) {
        return this.get<PatSnapCommonResponseData<WebSkillListResponse>>({
            url: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/api/web/skill/list`,
            params,
        }).then(res => res.data as WebSkillListResponse);
    }

    getDetail(name: string) {
        return this.get<PatSnapCommonResponseData<WebSkillDetailItem>>({
            url: `/${encodeURIComponent(name)}`,
        }).then(res => res.data as WebSkillDetailItem);
    }

    create(data: WebSkillCreateRequest) {
        return this.post<PatSnapCommonResponseData<WebSkillCreateData>>({
            url: '/create',
            data,
        }).then(res => res.data as WebSkillCreateData);
    }

    enable(name: string) {
        return this.post<PatSnapCommonResponseData<WebSkillEnableData>>({
            url: `/${encodeURIComponent(name)}/enable`,
        }).then(res => res.data as WebSkillEnableData);
    }

    disable(name: string) {
        return this.post<PatSnapCommonResponseData<WebSkillEnableData>>({
            url: `/${encodeURIComponent(name)}/disable`,
        }).then(res => res.data as WebSkillEnableData);
    }

    remove(name: string) {
        return this.request<PatSnapCommonResponseData<WebSkillDeleteData>>({
            url: `/${encodeURIComponent(name)}`,
            method: 'DELETE',
        }).then(res => res.data as WebSkillDeleteData);
    }
}
